import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { HiMap, HiViewGrid } from 'react-icons/hi';

const Header = ({ activeTab, setActiveTab }) => {
  const location = useLocation();
  const isExplorePage = location.pathname === '/explore';

  return (
    <header className="site-header">
      <div className="header-brand">
        <Link to="/" className="brand-link">
          <img src="/logo_v2_nav.png" alt="MHM Logo" className="header-logo" />
          <span className="header-title">Music History Museum of Montreal</span>
        </Link>
      </div>
      
      <nav className="site-nav">
        <Link 
          to="/about" 
          className={location.pathname === '/about' ? 'nav-link active' : 'nav-link'}
        >
          about
        </Link>
        <Link 
          to="/explore" 
          className={location.pathname === '/explore' ? 'nav-link active' : 'nav-link'}
        >
          explore
        </Link>
        {isExplorePage && (
          <div className="nav-tabs">
            <button 
              className={`nav-tab-button ${activeTab === 'map' ? 'active' : ''}`}
              onClick={() => setActiveTab('map')}
              title="Map View"
            >
              <HiMap />
            </button>
            <button 
              className={`nav-tab-button ${activeTab === 'list' ? 'active' : ''}`}
              onClick={() => setActiveTab('list')}
              title="List View"
            >
              <HiViewGrid />
            </button>
          </div>
        )}
      </nav>
      
      <div className="kofi-button-container">
        <a 
          href="https://ko-fi.com/P5P81FNY15" 
          target="_blank" 
          rel="noopener noreferrer"
          className="kofi-button"
        >
          <img src="/kofi_symbol.svg" alt="Ko-fi" className="kofi-icon" />
          <span className="kofi-button-text">Support</span>
        </a>
      </div>
    </header>
  );
};

export default Header;